export default "skymp5-front/19db134d885a9b3cb8633d17ca50ed68.png";